const isKitchenPackage = term => term && term.length > 0 && term.includes('Kitchen Package');

function checkProductContent(itemData) {
  return {
    hasImage1: Boolean(itemData.image1WithHeightAndWidth),
    hasImage2: Boolean(itemData.image2WithHeightAndWidth),
    hasImage3: Boolean(itemData.image3WithHeightAndWidth),
    hasMobileImage1: Boolean(itemData.mobileImage1Override),
    hasMobileImage2: Boolean(itemData.mobileImage2Override),
    hasMobileImage3: Boolean(itemData.mobileImage3Override),
    hasFirstRichTextContent: Boolean(itemData.richTextContent),
    hasSecondRichTextContent: Boolean(itemData.secondRichTextContent),
    hasThirdRichTextContent: Boolean(itemData.thirdRichTextContent),
    hasMainVideo: Boolean(itemData.vimeoLink) || Boolean(itemData.mainVideo),
    hasGallery: Boolean(itemData.gallery && itemData.gallery.length > 0),
  };
}
function isWarrantyProduct(slug) {
  return slug && slug.includes('years');
}

function getProductColor(itemData) {
  return itemData.productOptions?.Color?.choices[0]?.description;
}

module.exports = {
  isKitchenPackage,
  checkProductContent,
  isWarrantyProduct,
  getProductColor,
};
